<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">

              <h5>Asigne los talleres que serán evaluadas por los padres de familia</h5>
                <dx-data-grid
                    id="tabla"
                    [dataSource]="DataMaterias"
                    [(selectedRowKeys)]="selectedRows"
                    (onContentReady)="contentReady($event)"
                    (onSelectionChanged)="selectionChangedHandler($event)"
                    (onRowPrepared)="onRowPrepared($event)"
                    (onRowClick)="onRowClick($event)"
                    >
                      <dxo-search-panel
                        [visible]="true"
                        [highlightCaseSensitive]="true"
                      ></dxo-search-panel>
                      <dxo-paging [pageSize]="0"></dxo-paging>
                      <dxo-grouping #expand [autoExpandAll]="false" ></dxo-grouping>
                      <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
                      <dxo-selection mode="multiple" [showCheckBoxesMode]="'always'" *ngIf="identificador == 1"></dxo-selection>
                      <dxi-column [allowEditing]="!visualizador" *ngIf="visualizador"
                      alignment="center"
                      dataField="activo"
                      caption="Selección"
                      dataType="boolean">
                      </dxi-column>
                      <dxi-column dataField="tallerextracurricularid" [groupIndex]="0" groupCellTemplate="groupCellTemplatetaller"></dxi-column>
                      <dxi-column dataField="grado" caption="Grado" [allowEditing]="false"></dxi-column>
                      <dxi-column dataField="matricula" caption="Matricula" [allowEditing]="false"></dxi-column>
                      <dxi-column dataField="alumno" caption="Alumno" [allowEditing]="false"></dxi-column>

                      <div *dxTemplate="let cellInfo of 'groupCellTemplatetaller'; let idx = index">
                        <div class="accionEncabezado">
                          <div class="accionEncabezado__acciones">
                            <checkBoxCustom [sinMargen]="true"
                              class="dx-select-checkbox dx-datagrid-checkbox-size"
                              [disabled]="visualizador"
                              [(ngModel)]="talleres[cellInfo.value]"
                              (click)="$event.stopPropagation()"
                              (ngModelChange)="setChildState(cellInfo.component, cellInfo.data, $event)">
                            </checkBoxCustom>
                          </div>
                          <div class="accionEncabezado__titulo">
                            {{GetNombreTaller(cellInfo.text)}}
                          </div>
                          <div class="accionEncabezado__accionesintermedio">
                            <dx-select-box
                              [items]="cellInfo.data.items ? cellInfo.data.items[0].listapuestos : cellInfo.data.collapsedItems[0].listapuestos"
                              displayExpr="nombre"
                              valueExpr="puestoid"
                              [(ngModel)]="talleresSeleccionados[cellInfo.value]"
                              [dropDownOptions]="{ fullScreen: false, width: 'auto', height: 'auto' }"
                              [showDropDownButton]="true"
                              [opened]="false"
                              (ngModelChange)="onTalleresChanged($event, cellInfo)"
                              [dropDownButtonTemplate]="'customDropDownButton'"
                              class="multi-select-talleres"
                              applyValueMode="useButtons">
                              <div *dxTemplate="let data of 'customDropDownButton'">
                                <div class="dx-dropdowneditor-icon"></div>
                              </div>
                            </dx-select-box>
                          </div>
                        </div>
                      </div>
                </dx-data-grid>
            </section>
        </div>
    </div>
</div>
